import React, { ReactElement } from 'react';
import { Head } from '@ecommerce/nest-ssr/components';

import { useMetaTags } from 'hooks/use-meta-tags';

import favicon from 'assets/favicon.inline.svg';
import GtmHead from 'components/gtm/gtm-head';
import AdConfig from 'components/ads/ad-config';
import GemiusHead from 'components/gemius-head';

const MetaTags: React.FC<{ gtmKey: string; }> = ({ gtmKey }): ReactElement => {
    const metaTags = useMetaTags();

    return (
        <Head>
            <meta charSet="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <link rel="shortcut icon" href={favicon} />
            <meta name="copyright" content={`Copyright (c) 2007-${(new Date()).getFullYear()} by Opineo.pl`} />
            <meta name="keywords" content={metaTags.keywords || 'oceny sklepów, zakupy internetowe, opinie, opinie o sklepie'} />
            <meta name="description" content={metaTags.description || 'setki sklepów i tysiące ocen - sprawdź przed zakupem'} />
            <>
                {metaTags?.robots?.length && <meta name="robots" content={metaTags.robots.join(',')} />}
                {metaTags.canonical && <link rel="canonical" href={metaTags.canonical} />}
            </>
            <title>
                {metaTags.title || 'Opineo.pl - serwis oceniający sklepy internetowe'}
            </title>
            <GtmHead gtmKey={gtmKey} />
            <GemiusHead />
            <AdConfig />
        </Head>
    );
};

export default MetaTags;
